import { render, staticRenderFns } from "./dialogCopy.vue?vue&type=template&id=5c2afcc9&scoped=true&"
import script from "./dialogCopy.vue?vue&type=script&lang=js&"
export * from "./dialogCopy.vue?vue&type=script&lang=js&"
import style0 from "./dialogCopy.vue?vue&type=style&index=0&id=5c2afcc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2afcc9",
  null
  
)

export default component.exports